import { useRequestsHandlerData } from './useRequestsHandlerData';
import { useModal } from './useModal';
import { useApplicationCallbacks } from '../providers/application-callbacks';

export const useBeautyRedirect = () => {
  const callbacks = useApplicationCallbacks();
  const { addModal } = useModal();

  useRequestsHandlerData([
    {
      address: 'requestsGetBeautyRoutine',
      fulfilled({ list: [{ day_limit } = {}] }) {
        if (!isFinite(day_limit)) return;
        addModal({
          type: 'procedureModal',
          props: { callbacks, isHaveRoutines: day_limit > 0, procedureRemainder: day_limit },
        });
      },
    },
  ]);
};
